











































import Vue from 'vue';

import settingsPannel from '../settings.vue';

import { MDCTextField } from '@material/textfield';
import { MDCList } from '@material/list';
import { MDCRipple } from '@material/ripple';
import { MDCTextFieldIcon } from '@material/textfield/icon';

import Axios from 'axios';

import { User } from '../../../libs/classes/user';

interface Data {
  users: User[];

  searchUser: string;
  userListMDC: any;
}

export default Vue.extend({
  data(): Data {
    return {
      users: [],
      userListMDC: null,

      searchUser: '',
    };
  },
  mounted() {
    this.fillupUsersList();
    this.makeUpElements();
  },
  methods: {
    makeUpElements() {
      const textFields: any = document.querySelectorAll('#users .mdc-text-field');
      for (const textFieldElem of textFields) {
        const textField = new MDCTextField(textFieldElem);
      }

      if (this.userListMDC === null) {
        const listElem: any = document.querySelector('#users .mdc-list');
        const list = new MDCList(listElem);
        const listItemRipples = list.listElements.map((listItemEl) => new MDCRipple(listItemEl));
        this.userListMDC = list;
      } else {
        const listItemRipples = this.userListMDC.listElements.map((listItemEl: any) => new MDCRipple(listItemEl));
      }

      const MDCTextFieldIconElem: any = document.querySelector('#users .mdc-text-field--with-leading-icon');
      const icon = new MDCTextFieldIcon(MDCTextFieldIconElem);
    },
    fillupUsersList() {
      const vue: any = this;
      Axios.get('/API/admin/getUsers').then((resp: any) => {
        const users: User[] = [];

        for (const userData of resp.data) {
          const user = new User(userData);
          users.push(user);
        }

        vue.users = users;
      }).catch((err: any) => {
        console.warn(err);
      });
    },
    openUser(user: User) {
      this.$router.push('/editUser/' + user.id);
    },
    searchUserFunc() {
      Axios.get('/API/admin/getUsers', {
        params: {
          Search: this.searchUser,
        },
      }).then((resp: any) => {
        this.users = [];

        for (const userResp of resp.data) {
          const user = new User(userResp);
          this.users.push(user);
        }
      });
    },
  },
  destroyed() {
    this.userListMDC.destroy();
  },
  components: {
    settingsPannel,
  },
});
